import { T2 } from "../theme";
import { getCl } from "../utils";

export default function Gauge(props) {
  var v = props.value, cl = getCl(v), r = 54, cx = 64, cy = 64, circ = Math.PI*r, dash = (v/10)*circ;
  return (
    <svg viewBox="0 0 128 80" width="160" height="100">
      <path d={"M "+(cx-r)+" "+cy+" A "+r+" "+r+" 0 0 1 "+(cx+r)+" "+cy} fill="none" stroke="#222" strokeWidth="10" strokeLinecap="round"/>
      <path d={"M "+(cx-r)+" "+cy+" A "+r+" "+r+" 0 0 1 "+(cx+r)+" "+cy} fill="none" stroke={cl.cor} strokeWidth="10" strokeLinecap="round" strokeDasharray={dash+" "+circ}/>
      <text x={cx} y={cy-8} textAnchor="middle" fontSize="22" fontWeight="700" fill={cl.cor}>{v}</text>
      <text x={cx} y={cy+10} textAnchor="middle" fontSize="10" fill={T2}>de 10</text>
    </svg>
  );
}
